import { Api } from './axios-config';

export interface ICommissionItemDetail {
  name: string;
  amount: number;
  commission: number;
  type: string;
  commissionGoalId: number | null;
  goalName: string | null;
  tierIndex: number | null;
  sequenceNumber: number;
  paidAmount: number;
  isFullyPaid: boolean;
}

export interface ICommissionAppointmentItem {
  appointmentId: number;
  date: Date;
  customerName: string;
  serviceAmount: number;
  productAmount: number;
  totalAmount: number;
  paymentMethod: number;
  paymentMethodName: string;
  cardFee: number;
  netAmount: number;
  servicesCommissionRate: number;
  commissionAmount: number;
  paidAmount: number;
  isFullyPaid: boolean;
  itemDetails: ICommissionItemDetail[];
}

export interface ICommissionEmployee {
  businessEmployeeId: number;
  employeeName: string;
  totalAppointments: number;       // distinct appointments (sintético unificado)
  servicesCommissionRate: number;  // taxa de comissão (sintético unificado)
  items: ICommissionAppointmentItem[];
  totalGrossRevenue: number;
  totalCardFees: number;
  totalNetRevenue: number;
  totalCommission: number;
}

export interface ICommissionGoalProgress {
  goalId: number;
  goalName: string;
  scope: string;
  currentProgress: number;
  targetProgress: number;
  currentTierIndex: number;
  currentTierLabel: string;
  nextTierLabel: string | null;
  nextTierMin: number | null;
  progressToNext: number;
  metric: string;
}

/** Helper: concatena os parâmetros de query para o endpoint /commission */
function buildCommissionParams(
  businessId: number,
  businessEmployeeId?: number,
  startDate?: Date,
  endDate?: Date
): string {
  const params = new URLSearchParams();
  params.append('businessId', businessId.toString());
  if (businessEmployeeId) params.append('businessEmployeeId', businessEmployeeId.toString());
  if (startDate) params.append('startDate', startDate.toISOString());
  if (endDate) params.append('endDate', endDate.toISOString());
  return params.toString();
}

/**
 * Endpoint unificado de comissões.
 * Retorna dados por profissional em uma única resposta.
 */
const getCommissions = async (
  businessId: number,
  businessEmployeeId?: number,
  startDate?: Date,
  endDate?: Date
): Promise<ICommissionEmployee[]> => {
  try {
    const params = buildCommissionParams(businessId, businessEmployeeId, startDate, endDate);
    const { data } = await Api.get<ICommissionEmployee[]>(`/commission?${params.toString()}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const commissionService = {
  getCommissions,
};

const getGoalProgress = async (
  businessEmployeeId: number
): Promise<ICommissionGoalProgress[]> => {
  try {
    const { data } = await Api.get<ICommissionGoalProgress[]>(`/commission/goal-progress?businessEmployeeId=${businessEmployeeId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const commissionGoalProgressService = {
  getGoalProgress,
};
